<template>
    <div>
        <v-row dense>
            <v-col cols=12>
                <span v-for="(link, idx) in safeLinks" :key="idx">
                    <span v-html="link.url"></span>
                    <span>&nbsp;<v-icon small v-on:click="deleteLink(link.id)">mdi-trash-can-outline</v-icon>&nbsp;&nbsp;</span>
                </span>
                <span v-if="this.show_create_link_button">
                    <span v-if="links != null && links.length > 0">&nbsp;</span>
                    <v-btn icon small v-on:click="showCreateLink()">
                        <v-icon>mdi-link-variant-plus</v-icon>
                    </v-btn>                    
                </span>
            </v-col>
        </v-row>
        <div v-if="this.show_create_link_container">
            <v-row dense>
                <v-col cols="12">
                    <v-container style="background-color: bisque;">
                        <v-row dense >
                            <span class="subtitle mx-6 mb-5">
                                <v-icon small class="mr-2">mdi-link-variant-plus</v-icon>
                                Create a new link
                            </span>
                            <v-spacer></v-spacer>
                            <v-btn icon x-small v-on:click="closeCreateLink()" class="mr-2">
                                    <v-icon>mdi-close</v-icon>
                                </v-btn>                                
                        </v-row>
                        <v-row no-gutters class="mx-6">
                            <v-col cols=11>
                                <v-text-field dense v-model="url" label="URL" single-line></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row no-gutters class="mx-6 mb-2">
                            <v-col cols="11">
                                <v-text-field dense v-model="url_text" label="URL tekst" single-line></v-text-field>
                            </v-col>
                            <v-col cols="1">
                                <span v-if="save_ok">
                                    <v-btn icon small v-on:click="createLink(url, url_text)" class="margin-btn">
                                        <v-icon>mdi-content-save-outline</v-icon>
                                    </v-btn>                                        
                                </span>
                            </v-col>
                        </v-row>
                        <transition name="fade">
                            <div v-if="!wellformed_url" class="error-msg"><v-icon color="red" class="mr-2 ml-5">mdi-close-circle</v-icon>This url is not valid and poses a security risk. This url cannot be saved like this.</div>
                        </transition>
                    </v-container>
                </v-col>
            </v-row>
        </div>
    </div>    
</template>

<script>
export default {
    watch:{
        links: {
            deep: true,
            handler(){
                this.$emit('updateData', {field: 'links', value: this.links});
            } 
        },
        wellformed_url(newVal) {
            if (newVal === false) {
                setTimeout(() => {
                    this.wellformed_url = true;
                }, 2000);
            }
        }        
    },
    props: {
        links: Array
    },         
    data() {
        return {
            show_create_link_container: false,
            show_create_link_button: true,
            url: '',
            url_text: '',
            wellformed_url: true,
        }
    },
    computed: {
        save_ok: function () {
            return (this.url != '' && this.url_text != '');
        },
        safeLinks() {
            return (this.links || []).map(link => {
                let url = link.url
                if (typeof url === 'string' &&  url.trim().toLowerCase().startsWith('<a ') && !/rel\s*=/.test(url)) {
                    // Insert rel="noopener noreferrer" before the closing '>'
                    url = url.replace(/<a([^>]*)>/i, // <-- 'i' flag for case-insensitive
                        (match, attrs) => {
                            // Add target if missing
                            if (!/target\s*=/.test(attrs)) {
                                attrs += ' target="_blank"'
                            }
                            attrs += ' rel="noopener noreferrer"'
                            return `<a${attrs}>`
                        }
                    )
                }
                return { ...link, url };
            })
        }        
    },       
    methods: {
        createLink(url, text) {    
            this.wellformed_url = true;
            let idx = 0
            if (this.links != null && this.links.length > 0) {
                idx = this.links.length + 1;
            }
            if (!url.toLowerCase().startsWith("http")) {
                url = 'https://' + url;
            }
            if (!this.isWellFormedUrl(url)) {
                console.log('invalid url: ' + url)
                this.wellformed_url = false;
                return;
            }
            let anchortag = '<a href="' + url + '" target="_blank" rel="noopener noreferrer">' + text + '</a>';
            let link = {id: idx, url: anchortag};
            this.links.push(link);
            this.closeCreateLink();
        },
        isWellFormedUrl(url) {
            const invalidChars = /[\s<>"\\{}|^]/
            const allowedProtocols = ['http:', 'https:']
            if (invalidChars.test(url)) return false
            try {
                new URL(url)
                return allowedProtocols.includes(new URL(url).protocol) ? true : false
            } catch (e) {
                return false
            }
        },
        showCreateLink() {
            this.show_create_link_container = true;
            this.show_create_link_button = false;
        },
        closeCreateLink() {
            this.url = '';
            this.url_text = '';
            this.show_create_link_container = false;
            this.show_create_link_button = true;
        },
        deleteLink(param) {
            let idx = this.findWithAttr(this.links, "id", param);
            this.links.splice(idx, 1);
        },
        findWithAttr(array, attr, value) {
            for(let i = 0; i < array.length; i += 1) {
                if(array[i][attr] === value) {
                    return i;
                }
            }
            return -1;
        },         
    }
}    
</script>

<style scoped>
.margin-btn {
    margin-top: 10px;
    margin-left: 10px;
}
.subtitle {
    color: gray;
    font-size: 14px;
    font-weight: 300;
}    
.fade-enter-active, .fade-leave-active {
    transition: opacity 0.7s;
}
.fade-enter, .fade-leave-to {
    opacity: 0;
}
.error-msg {
    color: red;
    font-weight: 500;
}    
</style>